import { AutoMap } from "@automapper/classes";
import { Anagrafica } from "../../common/anagrafica";

export class Dipendente {
  @AutoMap({ typeFn: () => Anagrafica })
  infortunato: Anagrafica;
}
